import { render } from "./AppMainContent.vue?vue&type=template&id=ed4d8202&scoped=true"
import script from "./AppMainContent.vue?vue&type=script&lang=js"
export * from "./AppMainContent.vue?vue&type=script&lang=js"

import "./AppMainContent.vue?vue&type=style&index=0&id=ed4d8202&scoped=true&lang=css"

import exportComponent from "/srv/m1port/dev/client/patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed4d8202"]])

export default __exports__